import { Component } from '@angular/core';
import { InlineSearchComponent } from '../inline-search/inline-search.component';

@Component({
    selector: 'lib-inline-search-navbar[configService]',
    templateUrl: './inline-search-navbar.component.html',
    styleUrls: ['./inline-search-navbar.component.css'],
    standalone: false
})
export class InlineSearchNavbarComponent<T> extends InlineSearchComponent<T> {

}
